import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            海量内容<span className="text-primary-500">一网打尽</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大内容分类，满足全家人的观影需求，总有你喜欢的
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="w-8 h-8 flex items-center justify-center bg-primary-500/90 text-background-50 rounded-lg text-sm">
                      <i className={cat.icon} />
                    </span>
                    <h3 className="text-lg font-heading font-semibold text-background-50">{cat.name}</h3>
                  </div>
                  <p className="text-xs text-background-50/70 line-clamp-1">{cat.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}